import { APIRequester } from './APIRequester';
import {
  AuthAPI,
  BankAPI,
  DistributionAPI,
  GovAPI,
  MarketAPI,
  OracleAPI,
  SlashingAPI,
  StakingAPI,
  SupplyAPI,
  TendermintAPI,
  TreasuryAPI,
  TxAPI,
} from './api';
import { Wallet } from './Wallet';
import { Numeric, Coins } from '../../core';
import { Key } from '../../key';

export interface LCDClientConfig {
  URL: string;
  chainID: string;
  gasPrices?: Coins.Input;
  gasAdjustment?: Numeric.Input;
}

const DEFAULT_OPTIONS: Partial<LCDClientConfig> = {
  gasPrices: { uluna: 0.015 },
  gasAdjustment: 1.4,
};

export class LCDClient {
  public config: LCDClientConfig;
  public apiRequester: APIRequester;

  // API access
  public auth: AuthAPI;
  public bank: BankAPI;
  public distribution: DistributionAPI;
  public gov: GovAPI;
  public market: MarketAPI;
  public oracle: OracleAPI;
  public slashing: SlashingAPI;
  public staking: StakingAPI;
  public supply: SupplyAPI;
  public tendermint: TendermintAPI;
  public treasury: TreasuryAPI;
  public tx: TxAPI;

  constructor(config: LCDClientConfig) {
    this.config = {
      ...DEFAULT_OPTIONS,
      ...config,
    };

    this.apiRequester = new APIRequester(this.config.URL);

    // instantiate APIs
    this.auth = new AuthAPI(this.apiRequester);
    this.bank = new BankAPI(this.apiRequester);
    this.distribution = new DistributionAPI(this.apiRequester);
    this.gov = new GovAPI(this.apiRequester);
    this.market = new MarketAPI(this.apiRequester);
    this.oracle = new OracleAPI(this.apiRequester);
    this.slashing = new SlashingAPI(this.apiRequester);
    this.staking = new StakingAPI(this.apiRequester);
    this.supply = new SupplyAPI(this.apiRequester);
    this.tendermint = new TendermintAPI(this.apiRequester);
    this.treasury = new TreasuryAPI(this.apiRequester);
    this.tx = new TxAPI(this);
  }

  wallet(key: Key): Wallet {
    return new Wallet(this, key);
  }
}
